import {QuillModules} from 'ngx-quill';

export const QUILL_MODULES: QuillModules = {
	toolbar: [
		['bold', 'italic', 'underline'],
		['blockquote'],
		[{ list: 'ordered'}, { list: 'bullet' }],
		[{ color: []}]
	],
	clipboard: {
		matchVisual: false
	}
};
